module.exports = __webpack_public_path__ + "img/otp_btn_bg.dabbe7d7.png";